/**
 * Pre-launch banner — shown on every screen of the redemption flow while
 * the ARC contract is the zero address. Copy is operator-approved
 * (AP-4 plan §4) and MUST NOT be edited without re-approval.
 */
export default function PreLaunchBanner() {
  return (
    <div
      data-testid="redeem-prelaunch-banner"
      className="rounded-md border border-[#00F0FF]/40 bg-[#00F0FF]/5 px-4 py-3"
    >
      <div className="flex items-start gap-3">
        <div className="mt-0.5 h-2 w-2 rounded-full bg-[#00F0FF] pulse-dot" />
        <p className="font-mono text-xs leading-relaxed text-white/85">
          <span className="text-[#00F0FF] uppercase tracking-[0.2em]">Pre-launch&nbsp;mode</span>
          <span className="ml-2 text-white/70">
            ArenaCoin is in pre-launch mode. On-chain ARC balance will appear
            after contract deployment. Redemptions may be reviewed before
            credit is issued.
          </span>
        </p>
      </div>
    </div>
  );
}
